import * as Yup from "yup";

import { IConsent } from "../models/consent.model";
import { useI18next } from "../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

export function getConsentsValidation(consents: IConsent[], t: ReturnType<typeof useI18next>['t']) {
    let validation: Record<string, any> = {};
    consents.forEach(consent => {
        const valueValidation = consent.isRequired ? (
            Yup.boolean().required(t('form.error.required.consent')).oneOf([true], t('form.error.required.consent'))
        ) : (
            Yup.boolean()
        );

        validation[`consent${consent.consentId}`] = Yup.object({
            consentId: Yup.number(),
            value: valueValidation,
        })
    })
    return Yup.object(validation);
}